// import Login from './Login.vue'
export default {
    wxLogin: (resolve) => require(['./login/WxLogin.vue'], resolve),
    pswLogin: (resolve) => require(['./login/PswLogin.vue'], resolve),
    my: {
        scanCode:(resolve)=> require(['./my/V2/ScanCode.vue'], resolve),
        tourist:(resolve)=> require(['./my/V2/Tourist.vue'], resolve),
        operators:(resolve)=> require(['./my/V2/OperatorsV2.vue'], resolve),
        codeRecord:(resolve)=> require(['./my/V2/CodeRecord.vue'], resolve),
        statistics:(resolve)=> require(['./my/V2/StatisticsV2.vue'], resolve),
        packQrcode:(resolve)=> require(['./my/V2/PackQrcode.vue'], resolve),
        userCenter:(resolve)=> require(['./my/V2/UserCenter.vue'], resolve),
        continuity:(resolve)=> require(['./my/V2/ContinuityV2.vue'], resolve),
        passWord:(resolve)=> require(['./login/PassWord.vue'], resolve),
        formList:(resolve)=> require(['./my/V2/FormList.vue'], resolve),
        formDetail:(resolve)=> require(['./my/V2/FormDetail.vue'], resolve),
        formSubmit:(resolve)=> require(['./my/V2/FormSubmit.vue'], resolve),
    },
    storeModule:{
        waiterQRcode:(resolve)=> require(['./storeModule/waiterQRcode.vue'], resolve),
        serverMsg:(resolve)=> require(['./storeModule/serverMsg.vue'], resolve),
        success:(resolve)=> require(['./storeModule/success.vue'], resolve),
        error:(resolve)=> require(['./storeModule/error.vue'], resolve),
        waitersList:(resolve)=> require(['./storeModule/waitersList.vue'], resolve),
        waitersDetail:(resolve)=> require(['./storeModule/waitersDetail.vue'], resolve)
    },
    luckDraw:{
        drawPage:(resolve)=> require(['./luckDraw/index.vue'], resolve),
        result:(resolve)=> require(['./luckDraw/result.vue'], resolve),
        demo:(resolve)=> require(['./demo.vue'], resolve),
        fakePage:(resolve)=> require(['./fakePage.vue'], resolve),
    }
}



// WEBPACK FOOTER //
// ./src/views/index.js